import { Outlet } from 'react-router-dom';

import { StateMachineProvider, createStore } from 'little-state-machine';

createStore({ event: {} });

function Events() {
  return (
    <div className="event-wrapper">
      <StateMachineProvider>
        <Outlet />
      </StateMachineProvider>
    </div>
  );
}

export default Events;
